import LoginForm from "../pages/login.vue";
import ForgotForm from "../pages/employeePages/employeeForgotPassword.vue";

// Employee Dashboard
import UpdatePassword from "../pages/employeePages/updatePassword.vue";
import EmployeeDashboard from "../pages/employeePages/employeeDashboard.vue";
import ManageEmployee from "../pages/employeePages/manageEmployee.vue";
import EmployeeProfile from "../pages/employeePages/employeeProfile.vue";
import EmployeeApprovalList from "../pages/employeePages/employeeApproveList.vue";
import ManagerDashboard from "../pages/employeePages/managerDashboard.vue";
import ComplaintsDashboard from "../pages/employeePages/complaintsDashboard.vue";
import ViewComplaints from "../pages/employeePages/viewComplaints.vue";
import GiftsApproval from "../pages/employeePages/giftsApproval.vue";
import EmployeeMisPage from "../pages/employeePages/employeeMisPage.vue";
import OnboardingPage from "../pages/employeePages/onboardingPage.vue";
import TasksPage from "../pages/employeePages/tasksPage.vue";
import EmployeeUserFormPage from "../pages/employeePages/employeeUserForm.vue";
import EmployeeUserExamPage from "../pages/employeePages/employeeUserExam.vue";
import EmployeeUserTrainingPage from "../pages/employeePages/employeeUserTraining.vue";
import EmployeeUserTrainingPDF from "../pages/employeePages/employeeUserTrainingPDF.vue";
import EmployeeComplaintFormPage from "../pages/employeePages/employeeComplaintForm.vue";
import UpdateEmployeeProfile from "../pages/employeePages/updateEmployeeProfile.vue";
// Employee Onboarding Settings
import Departments from "../pages/employeePages/employeeSettings/departments.vue";
import PlatformsSettings from "../pages/employeePages/employeeSettings/platformsSetting.vue";
import EmailTags from "../pages/employeePages/employeeSettings/emailTags.vue";
import WorkFlows from "../pages/employeePages/employeeSettings/workFlows.vue";
import WorkFlowsIt from "../pages/employeePages/employeeSettings/workFlowsIt.vue";
import GenralSettingsApproval from "../pages/employeePages/employeeSettings/genralSettingsApproval.vue";
import CustomFields from "../pages/employeePages/employeeSettings/customFields.vue";
import Styling from "../pages/employeePages/employeeSettings/styling.vue";
import AccessControl from "../pages/employeePages/employeeSettings/accessControl.vue";
import ComplaintTypes from "../pages/employeePages/employeeSettings/complaintTypes.vue";
import OptionOne from "../pages/employeePages/governance/optionOne.vue";
import OptionTwo from "../pages/employeePages/governance/optionTwo.vue";
import GoveranceAbc from "../pages/employeePages/governance/abc.vue";
import TrainingExams from "../pages/employeePages/training/training.vue";

// Forms
import RsOnboardingPage from "../pages/employeeNew/rsOnboardingPage.vue";
import RsForm from "../pages/employeeNew/rsForm.vue";
import FormConfigurationContainer from "../containers/FormConfigurationContainer";
import FormIntroContainer from "../containers/FormIntroContainer";
import FormDetailsContainer from "../containers/FormDetailsContainer";
import FormBuilderContainer from "../containers/FormBuilderContainer";
import FormCssContainer from "../containers/FormCssContainer";
import FormJsonContainer from "../containers/FormJsonContainer";
import FormJsContainer from "../containers/FormJsContainer";
import FormSettingsContainer from "../containers/FormSettingsContainer.vue";

let userType = localStorage.getItem("userType");
export default [
  {
    path: "/",
    name: "login",
    component: LoginForm,
    meta: { jwtRequiresAuth: false },
  },
  {
    path: "/forgot",
    name: "forgot-password",
    component: ForgotForm,
    meta: { jwtRequiresAuth: false },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: userType == 3 ? EmployeeDashboard : ManagerDashboard,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/update-password",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/manage-employee",
    name: "ManageEmployee",
    component: ManageEmployee,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-profile/:id",
    name: "EmployeeProfile",
    component: EmployeeProfile,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-approval-list",
    name: "EmployeeApprovalList",
    component: EmployeeApprovalList,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/manager-dashboard",
    name: "ManagerDashboard",
    component: ManagerDashboard,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/complaints-dashboard",
    name: "ComplaintsDashboard",
    component: ComplaintsDashboard,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/view-complaint-detail/:complaintId",
    name: "ViewComplaints",
    component: ViewComplaints,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/gifts-approval/:approvalId/:userType",
    name: "GiftsApproval",
    component: GiftsApproval,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/mis-graph",
    name: "EmployeeMisPage",
    component: EmployeeMisPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/onboarding",
    name: "OnboardingPage",
    component: OnboardingPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/goverance/one",
    name: "OptionOne",
    component: OptionOne,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/goverance/two",
    name: "OptionTwo",
    component: OptionTwo,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/goverance/abc",
    name: "GovernanceAbc",
    component: GoveranceAbc,
    meta: { jwtRequiresAuth: true },
  },

  {
    path: "/training-exams",
    name: "TrainingExams",
    component: TrainingExams,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/tasks",
    name: "TasksPage",
    component: TasksPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/departments",
    name: "Departments",
    component: Departments,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "ComplaintTypes",
    path: "/complaint-types",
    component: ComplaintTypes,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "WorkFlows",
    path: "/workflows-hr",
    component: WorkFlows,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/platform-settings",
    name: "PlatformsSettings",
    component: PlatformsSettings,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/email-tags",
    name: "EmailTags",
    component: EmailTags,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "WorkFlowsIt",
    path: "/workflows-it",
    component: WorkFlowsIt,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "GenralSettingsApproval",
    path: "/approval-type",
    component: GenralSettingsApproval,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "CustomFields",
    path: "/custom-fields",
    component: CustomFields,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "Styling",
    path: "/styling",
    component: Styling,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "AccessControl",
    path: "/access-control",
    component: AccessControl,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/emplyee-user-form/:taskId/:readOnly",
    name: "EmployeeUserFormPage",
    props: true,
    component: EmployeeUserFormPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/emplyee-user-exam/:taskId/:readOnly",
    name: "EmployeeUserExamPage",
    props: true,
    component: EmployeeUserExamPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/emplyee-training/:taskId/:readOnly",
    name: "EmployeeUserTrainingPage",
    props: true,
    component: EmployeeUserTrainingPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-pdf-training/:taskId/:readOnly",
    name: "EmployeeUserTrainingPDF",
    props: true,
    component: EmployeeUserTrainingPDF,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/add-complaint",
    name: "EmployeeComplaintFormPage",
    props: true,
    component: EmployeeComplaintFormPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/update-profile",
    name: "UpdateEmployeeProfile",
    component: UpdateEmployeeProfile,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-onboarding",
    name: "RsOnboardingPage",
    component: RsOnboardingPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: '/form',
    name: 'form',
    component: RsForm,
    props: true,
    meta: { jwtRequiresAuth: true },
    children: [
        {
            path: 'configuration',
            name: 'config',
            props: true,
            component: FormConfigurationContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'intro',
            name: 'intro',
            props: true,
            component: FormIntroContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'details',
            name: 'details',
            props: true,
            component: FormDetailsContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'builder',
            name: 'builder',
            props: true,
            component: FormBuilderContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'css',
            name: 'css',
            props: true,
            component: FormCssContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'json',
            name: 'json',
            props: true,
            component: FormJsonContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'js',
            name: 'js',
            props: true,
            component: FormJsContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'settings',
            name: 'settings',
            props: true,
            component: FormSettingsContainer,
            meta: { jwtRequiresAuth: true }
        }
    ]
},
];
